var _defs, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDaily(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-daily",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9,2h1v2h-1v-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13,2h1v2h-1v-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17,2h1v2h-1v-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21,2h1v2h-1v-2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23,4h-1v2h-1v-2h-3v2h-1v-2h-3v2h-1v-2h-3v2h-1v-2h-1c-1.1,0-2,.9-2,2v21c0,1.1.9,2,2,2h15c1.1,0,2-.9,2-2V6c0-1.1-.9-2-2-2Zm.11,14.92c0,.43-.35.78-.78.78h-13.66c-.43,0-.78-.35-.78-.77v-.05c0-.43.35-.78.78-.78h.42c0-2.37,1.3-4.4,3.2-5.52v1.52c0,.45.35.8.8.8s.8-.35.8-.8v-2.18c.51-.13,1.04-.22,1.6-.22s1.09.1,1.6.22v2.18c0,.45.35.8.8.8s.8-.35.8-.8v-1.52c1.91,1.12,3.2,3.15,3.2,5.52h.43c.43,0,.78.35.78.78v.03Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDaily);
export default __webpack_public_path__ + "static/media/icon-daily.f64d7eca7debccaf54465bef581e2a9e.svg";
export { ForwardRef as ReactComponent };